<template>
  <div class="h-full">
    <el-row :gutter="24" class="search-row">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-date-picker
          v-model="form.date2"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="提交时间"
          end-placeholder="提交时间"
          size="small"
          @change="commonChange"
        ></el-date-picker>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-select v-model="form.type" placeholder="答卷状态" clearable @change="commonChange" size="small">
          <el-option
            :label="opts.value"
            v-for="(opts, idx) in answer_status_options__all"
            :value="opts.key"
            :key="idx"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-select v-model="form.qcType" placeholder="质控方式" clearable @change="commonChange" size="small">
          <el-option :label="opts.value" v-for="(opts, idx) in answer_qcType_options" :value="opts.key" :key="idx"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-cascader
          placeholder="答卷位置"
          size="small"
          :options="cityOptions"
          :props="prop"
          clearable
          v-model="form.position"
          @change="commonChange"
          filterable
        ></el-cascader>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-date-picker
          v-model="form.date1"
          type="daterange"
          size="small"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="质控时间"
          end-placeholder="质控时间"
          @change="commonChange"
        ></el-date-picker>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-cascader v-model="form.channel" :options="channelOptions" @change="qdsChange" placeholder="回收渠道" clearable size="small"></el-cascader>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-select
          v-model="form.answerChannelId"
          placeholder="子渠道"
          clearable
          :disabled="channelsListOptions.length === 0"
          size="small"
          @change="commonChange"
        >
          <el-option
            v-for="(item, index) in channelsListOptions"
            :key="index"
            :label="item.channel_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-select v-model="form.auditId" placeholder="质控人" clearable @change="zkrChange" size="small">
          <el-option
            :label="(!validatenull(opt.weixinNickName || opt.name) ? (opt.weixinNickName || opt.name) : '未命名') + (opt.mobile ? '(' + opt.mobile + ')' : '')"
            :value="opt.customerId"
            v-for="opt in answerUserListOptions"
            :key="opt.customerId"
            >{{ (!validatenull(opt.weixinNickName || opt.name) ? (opt.weixinNickName || opt.name) : '未命名') + (opt.mobile ? '(' + opt.mobile + ')' : '') }}</el-option
          >
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="search-row">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-input
          type="text"
          v-model="form.answerID"
          placeholder="答卷ID"
          size="small"
          clearable
          @blur="commonChange"
          @clear="commonChange"
        ></el-input>
      </el-col>
      <template v-if="!isHidden251014">
      <el-col :span="18" :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="text-right">
        <template v-if="!currentConfig.hiddenImportAnswerBtn">
          <el-popover popper-class="el-pop" placement="bottom-end" trigger="hover">
            <div>
              <div class="line" @click="downloadTemplate">下载模板</div>
              <div class="line" @click="uploadDataByTemplate">上传文件</div>
            </div>
            <el-button v-if="!hidSurveyId.includes(getSurveyId)" size="small" slot="reference" icon="el-icon-upload" class="mr-1" :loading="uploadLoading"
              >导入答卷</el-button
            >
          </el-popover>
        </template>
        <template v-if="!currentConfig.hiddenExportAnswerBtn">
          <div class="fixed inset-0 bg-gray-100 bg-opacity-75" style="z-index: 99999" v-if="upLoadDataLoading">
            <el-progress
              class="flex justify-center relative top-1/2 transform -translate-y-1/2"
              type="circle"
              :percentage="percentage"
            ></el-progress>
          </div>
          <el-popover popper-class="el-pop" placement="bottom-end" trigger="hover">
            <div>
              <div class="line" @click="exportAnswerById">按选项序号下载</div>
              <div class="line" @click="exportAnswer">按选项文本下载</div>
              <div class="line" @click="exportSPSS">下载到SPSS（.sav）</div>
              <div class="line" @click="exportDownloader">下载多媒体文件</div>
              <div v-if="enabledExportByBrowser" class="line" @click="exportByBrowser">下载</div>
            </div>
            <el-button v-if="!hidAccount.includes(userInfo.phone) && !hidSurveyId.includes(getSurveyId)" size="small" slot="reference" type="primary" icon="el-icon-download">导出答卷</el-button>
          </el-popover>
          <!-- 导出记录 -->
          <el-popover placement="right" width="500" trigger="hover" @show="getExportRecordData">
            <!-- 导出记录表格 -->
            <data-table
              :data="exportRecordData"
              :columns="exportRecordOption.column"
              :page="exportRecordPage"
              :showPage="true"
              :loading="exportRecordLoading"
              @size-change="exportRecordSizeChange"
              @pagination-current-change="exportRecordCurrentChange"
              :height="'50vh'"
            >
              <!-- 导出类型 -->
              <template #type="{ row }">
                <span>{{ row.type | getExportType }}</span>
              </template>
              <!-- 状态 -->
              <template #status="{ row }">
                <span :style="{ color: getExportStatus(row.status).color }">{{ getExportStatus(row.status).text }}</span>
              </template>
              <!-- 操作 -->
              <template #opt="{ row }">
                <el-tooltip :disabled="!!row.url" content="下载链接正在生成，请稍后" placement="top">
                  <el-button type="text">
                    <span v-if="row.status ==3" class=" text-gray-400">已过期</span>
                    <a v-else-if="row.url" :href="row.url" target="_blank" class="text-theme">下载</a>
                    <span v-else class=" text-gray-400">下载</span>
                  </el-button>
                </el-tooltip>
              </template>
            </data-table>
            <el-button v-if="!hidSurveyId.includes(getSurveyId) && !hidAccount.includes(userInfo.phone)" size="small" slot="reference" type="primary" icon="" class="ml-1">导出记录</el-button>
          </el-popover>
        </template>
      </el-col>
      </template>
    </el-row>
    <!-- 表格组件 -->
    <common-answer-list :option="isHidden251014 ? option251014 : option" :slotsConfig="slotsTemplates" ref="child" :queryParams="form">
      <template slot="serialNumber" slot-scope="{ scope }">
        <div>{{ scope.row.serialNumber }}</div>
      </template>
      <!-- 答卷状态 -->
      <template slot="type" slot-scope="{ scope }">
        <div class="flex justify-center">
        <Status
          v-if="scope.row.channel === 9 && typeConfig__proxy[scope.row.type]"
          :pointColor="colorStateList[typeConfig__proxy[scope.row.type].tagType]"
          :text="typeConfig__proxy[scope.row.type].label"
        />
        <!-- <el-tag
          size="medium"
          v-if="scope.row.channel === 9 && typeConfig__proxy[scope.row.type]"
          :type="typeConfig__proxy[scope.row.type].tagType"
          >{{ typeConfig__proxy[scope.row.type].label }}</el-tag
        > -->
        <!-- <el-tag v-else-if="typeConfig[scope.row.type]" size="medium" :type="typeConfig[scope.row.type].tagType">{{
          typeConfig[scope.row.type].label
        }}</el-tag> -->
        <Status
          v-else-if="typeConfig[scope.row.type]"
          :pointColor="colorStateList[typeConfig[scope.row.type].tagType]"
          :text="typeConfig[scope.row.type].label"
        />
        </div>
      </template>
      <!-- 回收渠道 -->
      <template slot="channel" slot-scope="{ scope }">
        <span>{{ channel_list_options[scope.row.channel] }}</span>
      </template>
      <!-- 子渠道 12字以内单行显示，12字以上一行显示 -->
      <template slot="name" slot-scope="{ scope }">
        <el-tooltip placement="top" :content="scope.row.name" v-if="scope.row.name && scope.row.name.length > 12">
          <span>{{ scope.row.name.substring(0, 12) + '...' }}</span>
        </el-tooltip>
        <span v-if="scope.row.name && scope.row.name.length < 13">{{ scope.row.name }}</span>
      </template>
      <!-- 质控方式 -->
      <template slot="qcType" slot-scope="{ scope }">
        <span>{{ getQcTypeValue(scope.row.qcType) }}</span>
      </template>
      <!-- 质控人 -->
      <template slot="user" slot-scope="{ scope }">
        <el-tooltip placement="top">
          <div slot="content">{{ scope.row.userID }}</div>
          <span>{{ scope.row.user }}</span>
        </el-tooltip>
      </template>
      <!-- 一审质控人 -->
      <template slot="supervisorName" slot-scope="{ scope }">
        <el-tooltip placement="bottom">
          <div slot="content">{{ scope.row.supervisorId }}</div>
          <span>{{ scope.row.supervisorName }}</span>
        </el-tooltip>
      </template>
    </common-answer-list>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import CommonAnswerList from './components/CommonAnswerList'
import {
  channel_list_options,
  typeConfig,
  typeConfig__proxy,
  answer_status_options__all,
  answer_qcType_options,
  getQcTypeValue
} from './config'
import citylist from '@/assets/js/config/citydata'
import {
  subChannel,
  getImportTemplateIds,
  importTemplateData,
  getAnswerUserList,
  surveyExportRecord
} from '@/api/wenjuan/answerList'
import { utils_transFormHandlerXlsx, utils_successText, handleParams, handleResult } from './utils'
import { option, exportRecordOption, option231025, option251014 } from './crud/all'
import { successMessage, errorMessage } from './utils'
import Status from '@/components/base/Status.vue'
import DataTable from '@/components/base/DataTable'
import { querySampleServiceByUser } from "@/api/wenjuan/sampleService"
import { validatenull } from '@/assets/js/validate'
import { mapGetters } from 'vuex'
import { hidAccount } from '@/assets/js/customVariables.js'
import pageView from '@/mixins/pageView'

export default {
  name: 'AllDownload',
  mixins:[pageView],
  components: {
    CommonAnswerList,
    Status,
    DataTable
  },
  filters: {
    getExportType(type) {
      switch (type) {
        case 1:
          return '按序号导出'
        case 2:
          return '按文本导出'
        case 3:
          return '多媒体下载'
        case 4:
          return '问卷word导出'
        case 5:
          return '答卷word导出'
        case 6:
          return '答卷pdf导出'
        default:
          return ''
      }
    }
  },
  data() {
    return {
      // TODO: 这个属于临时解决方案，后期需要改进
      colorStateList: {
        ['warning']: '#E8A31B',
        ['success']: '#00BE6A',
        ['danger']: '#E34152',
        ['info']: '#dddddd'
      },
      percentage: 10,
      upLoadDataLoading: false,
      uploadLoading: false,
      getQcTypeValue,
      // 初始化 插槽 所有功能的插槽先创建出来
      slotsTemplates: [
        'serialNumber', //流水编号
        'search', // 搜索
        'type', // 答卷状态
        'channel', // 回收渠道
        'name', // 子渠道
        'user', // 质控员
        'qcType', //质控方式
        'supervisorName' // 一审质控人
      ],
      // 表格配置
      option,
      option231025,
      option251014,
      channel_list_options,
      typeConfig,
      typeConfig__proxy,
      answer_status_options__all, // 问卷状态下拉options
      cityOptions: citylist,
      answer_qcType_options, //质控方式下拉options
      // 查询条件 form
      form: {
        answerID: '',
        type: '',
        position: [],
        channel: '',
        answerChannelId: '',
        auditId: '',
        date1: '',
        date2: '',
        qcType: ''
      },
      prop: {
        // value: "s",
        // label: "s",
        // children: "c",
        checkStrictly: true,
        expandTrigger: 'hover'
      },
      channelsListOptions: [], // 子渠道options
      answerUserListOptions: [], // 质控人options
      tableHeight: 0,
      //导出记录
      exportRecordOption,
      exportRecordData: [],
      exportRecordPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
        pageSizes: [10, 30, 50, 100],
        layout: 'total, prev, pager, next, jumper'
      },
      exportRecordLoading: false,
      channelOptions: [{
        value: '0',
        label: '网络调查'
      },{
        value: '2',
        label: '面对面访问'
      },{
        value: '3',
        label: '样本-后台添加'
      },{
        value: '4',
        label: '样本-邀请添加'
      },{
        value: '5',
        label: '短信发送'
      },{
        value: '7',
        label: '电话访问'
      },{
        value: '8',
        label: '样本导入'
      },{
        value: '9',
        label: '委托代理'
      },{
        value: '10',
        label: '样本库推送'
      },{
        value: '12',
        label: '样本服务',
        children: []
      },{
        value: '17',
        label: '定向发布（企业员工）'
      },{
        value: '18',
        label: '定向发布（外部组织）'
      }],
      hidAccount
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 231025定制修改
    // isHidden () {
    //   return !['VozgS6lE', 'ykXuIvSs', '8kC4VPaC', 'muVl4qit', 'LqL0g5sk', 'JXqqCR5H', '6mX3u8qQ', 'oDsNkZ2v', 'GuJEzYlQ', 'XgLFnK8v', 'J4DyNMlq', 'A8mZBb4g', '7X6WWy1B', 'KYK3w5L7', '24SBTKpQ', 'EW3ObZuY'].includes(this.$route.params.id)
    // },
    // 251014定制修改
    isHidden251014 () {
      return ["f1jdehuT","L4lGWYc2","jTomBpul","VPOAZQGI","VstPRoby","LbbchB8A","AIUJBRZR","jvRH08Jo","pCF6fATL","l0ZJLX53","6uEldbNV",].includes(this.$route.params.id)
    },
    getParams() {
      return {
        size: this.exportRecordPage.pageSize,
        current: this.exportRecordPage.currentPage,
        surveyId: this.$route.params.id
      }
    },
    getExportStatus() {
      return function (status) {
        switch (status) {
          case 0:
            return { text: '导出中', color: '#E8A31B' }
          case 1:
            return { text: '导出成功', color: '#00BE6A' }
          case 2:
            return { text: '导出失败', color: '#E34152' }
          case 3:
            return { text: '链接失效', color: '#E34152' }
          default:
            return { text: '', color: '' }
        }
      }
    },
    channelList() {
      return this.channel_list_options
    },
    getSurveyId() {
      return GlobalConfig.getSurveyId()
    },
    hidSurveyId() {
      return GlobalConfig.getHideSurveyIds()
    },
    enabledExportByBrowser(){
      return this.$store.getters.otherSetting?.enabledExportByBrowser
    }
  },
  methods: {
    validatenull,
    // 获取样本服务数据
    getSampleServiceData() {
      querySampleServiceByUser(GlobalConfig.getSurveyId()).then(res => {
        if(res.data.code !== 0 || res.data.data.length === 0) return
        res.data.data.forEach((item, index) => {
          let unit = {
            value: String(item.id),
            label: `第 ${index + 1} 次样本服务`
          }
          this.channelOptions[9].children.push(unit)

          this.channelList[item.id] = `样本服务-第 ${index + 1} 次样本服务`
        })
      }).catch((err) => {console.log(err)})
    },
    // 打开上传弹层
    uploadDataByTemplate() {
      let input = document.createElement('input')
      let _self = this
      input.type = 'file'
      input.click()
      input.onchange = function () {
        _self.upLoadDataLoading = true
        _self.percentage = 10
        let file = this.files[0]
        if (!file.name.endsWith('.xlsx')) {
          _self.templateError('文件格式错误，请按规范编辑模板上传', _self.downloadTemplate)
          _self.upLoadDataLoading = false
          return
        }
        _self.xlsxData2SampleData(file)
      }
    },
    xlsxData2SampleData(data) {
      importTemplateData(handleParams(data, this.$route.params.id))
        .then(res => {
          this.upLoadDataLoading = false
          handleResult(res, this.$createElement, this.downloadTemplate, this.$msgbox)
          this.$refs.child.getTableData()
        })
        .catch(err => {
          // this.$message.error(err.message);
          this.upLoadDataLoading = false
        })
    },
    templateError(msg, clickFunction) {
      const h = this.$createElement
      let _self = this
      this.$msgbox({
        title: msg,
        message: h('p', null, [
          h(
            'p',
            {
              class: ['text-wjb', 'cursor-pointer'],
              on: {
                click() {
                  clickFunction()
                }
              }
            },
            '下载模板'
          )
        ]),
        confirmButtonText: '确定'
      }).then(action => {})
    },
    // 下载模板
    downloadTemplate() {
      this.uploadLoading = true
      getImportTemplateIds({ surveyId: this.$route.params.id })
        .then(res => {
          window.location.href = res.data.data
        })
        .catch(err => {})
        .finally(() => {
          this.uploadLoading = false
        })
    },
    // 统一change方法：提交时间、答卷状态、回收渠道（单独处理）、子渠道、答题位置、质控时间、答卷ID
    commonChange() {
      this.$refs.child.getTableData()
    },
    // 选择 回收渠道 change事件
    qdsChange(v) {
      // 清空子渠道
      this.form.answerChannelId = ''
      this.channelsListOptions = []
      this.$refs.child.getTableData()
      if (!v || v.length === 0 || v.length === 2) return
      let channel = v[v.length - 1]
      subChannel(channel, this.$route.params.id)
        .then(res => {
          this.channelsListOptions = (res.data && res.data.data) || []
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 质控人查询
    zkrChange() {
      this.$refs.child.getTableData()
    },
    exportAnswer() {
      this.$refs.child.exportAnswer()
    },
    exportAnswerById() {
      this.$refs.child.exportAnswerById()
    },
    exportSPSS() {
      this.$refs.child.exportSPSS()
    },
    exportDownloader() {
      this.$refs.child.exportDownloader()
    },
    exportByBrowser(){
      this.$refs.child.exportByBrowser()
    },
    /* -----答卷导出记录------ */
    exportRecordSizeChange(val) {
      this.exportRecordPage.currentPage = 1
      this.exportRecordPage.pageSize = val
      this.getExportRecordData()
    },
    exportRecordCurrentChange(val) {
      this.exportRecordPage.currentPage = val
      this.getExportRecordData()
    },
    getExportRecordData() {
      this.exportRecordLoading = true
      surveyExportRecord(this.getParams)
        .then(res => {
          // console.log(res)
          if (res.data.code !== 0) {
            this.$message.warning(res.data.msg)
            return
          }
          this.exportRecordData = res.data?.data?.records || []
          this.exportRecordPage.total = res.data?.data?.total ?? 0
        })
        .finally(() => {
          this.exportRecordLoading = false
        })
    }
    /* -----答卷导出记录------ */
  },
  mounted() {
    if (!this.$route.params.id) {
      this.$message({
        message: '缺少参数，请回到我的问卷列表',
        type: 'error'
      })
      return
    } else {
      GlobalConfig.setSurveyId(this.$route.params.id)
    }
    if (this.$route.query.channel) {
      this.form.channel = this.$route.query.channel
    }
    // 初始列表 要用mounted 不能用created
    this.$refs.child.getList()
    // 查询质控人下拉框
    getAnswerUserList({
      fieldName: 'auditName',
      surveyId: this.$route.params.id
    }).then(res => {
      this.answerUserListOptions = (res.data && res.data.data) || []
    })
    this.getSampleServiceData()
  }
}
</script>

<style lang="scss" scoped>
.queryBtnBox {
  @apply text-center;
}
.search-row {
  .el-col {
    @apply mb-4;
  }
  .el-date-editor--daterange.el-input__inner,
  .el-cascader,
  .el-select {
    @apply w-full;
  }
  ::v-deep .el-range-separator {
    color: #8a8a8a;
    font-size: 13px;
    @apply w-5;
  }
}
.line {
  @apply cursor-pointer py-2 px-2 text-medium leading-22 text-theme-black-650 text-left  hover:bg-theme-gray hover:text-theme;
}
</style>
